import { render, staticRenderFns } from "./Email.vue?vue&type=template&id=006d9ca7"
import script from "./Email.vue?vue&type=script&lang=js"
export * from "./Email.vue?vue&type=script&lang=js"
import style0 from "./Email.vue?vue&type=style&index=0&id=006d9ca7&prod&lang=css"
import style1 from "./Email.vue?vue&type=style&index=1&id=006d9ca7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports